import { ROTATES, ROTATE_REQUEST, STATUS_NOTICE_MESSAGE, PRINT_CONFIRMATION_CLEAR_MESSAGES, STATUS_ERR_MESSAGE, PRINT_CONFIRMATION_RESPONSE, ROWS_DATA_SELECTED_INDEX_STATE, FETCH_INVOICES_PRINT_RECORD_PRINTED, FETCH_RESET_INVOICES_PRINT, FETCH_INVOICES_PRINT, FETCH_INVOICES} from '../actions/actionTypes';

const initialState = {
    items_fetchInvoices: [],
    items_fetchInvoicesPrint: [],  
    items_fetchInvoicesProcessingPrintedStatus: {},
    items_rowsDataSelectedIndexState: [],
    items_printConfirmationResponseState: [],
    items_invoiceErrorMessageState: [],
    items_invoiceNoticeMessageState: [],  
    validRotatesPartno: false,

}

const invoicesReducer = (state = initialState, action) => {
    switch(action.type){
        case FETCH_INVOICES:
            return {
                ...state,
                items_fetchInvoices: action.payload
            }  
        case FETCH_INVOICES_PRINT:
            return {
                ...state,
                items_fetchInvoicesPrint: action.payload
            }
        case FETCH_RESET_INVOICES_PRINT:
            return {
                ...state,
                items_fetchInvoicesPrint: []
            }    
        case FETCH_INVOICES_PRINT_RECORD_PRINTED:
            return {
                ...state,
                items_fetchInvoicesProcessingPrintedStatus: action.payload
            }  
        case ROWS_DATA_SELECTED_INDEX_STATE:
            return {
                ...state,
                items_rowsDataSelectedIndexState: action.payload
            }
        case PRINT_CONFIRMATION_RESPONSE:
            return {
                ...state,
                items_printConfirmationResponseState: action.payload,
                items_invoiceErrorMessageState: [],
                items_invoiceNoticeMessageState: []
            }
        case STATUS_ERR_MESSAGE:
            return {
                ...state,
                items_invoiceErrorMessageState: action.payload,
                items_printConfirmationResponseState: [],
                items_invoiceNoticeMessageState: []
            }   
        case PRINT_CONFIRMATION_CLEAR_MESSAGES:
            return {
                ...state,
                items_invoiceErrorMessageState: [],
                items_printConfirmationResponseState: [],
                items_invoiceNoticeMessageState: []
            }      
        case STATUS_NOTICE_MESSAGE:
            return {
                ...state,
                items_invoiceNoticeMessageState: action.payload,
                items_printConfirmationResponseState: [],
                items_invoiceErrorMessageState: []
            }             
                           
        default:
            return state;
    }
}

export { invoicesReducer };